import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import Select from "react-select";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNotification } from "../../views/context/NotificationContext";
const appAccessOptions = [
  { value: "hms", label: "HMS" },
  { value: "office", label: "WorkWise" },
  { value: "pos", label: "POS" },
  { value: "digital-menu", label: "DIGITAL MENU" },
  { value: "channel-manager", label: "Channel Manager" },
    { value: "booking-engine", label: "Booking Engine" },
    { value: "dynamic-price", label: "Dynamic Price" },


   { value: "feedback", label: "Pulse360" },
];
const billingCycleOptions = [
  { value: "monthly", label: "Monthly" },
  { value: "yearly", label: "Yearly" }
];
const planOptions = [
  { value: 1, label: "Trial" },
  { value: 2, label: "Professional" },
  { value: 3, label: "Enterprise" }
];
const CompanyModelPopup = ({ onSave, company, isEditing, partners, onClose }) => {
  const { register, handleSubmit, formState: { errors }, reset, setValue, clearErrors, control, watch } = useForm();
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const companyEmail = watch("email");
    const { notify } = useNotification();
  useEffect(() => {
    if (isEditing && company) {
      setValue("company_name", company.company);
      setValue("contactperson", company.contactperson);
      setValue("contactdesignation", company.contactdesignation);
      setValue("email", company.email);
      setValue("phone", company.phone);
      setValue("location_address", company.address);
      setValue("billingcycle", billingCycleOptions.find(opt => opt.value === company.billingcycle));
      setValue("plandate", company.plandate ? new Date(company.plandate) : null);
      setValue("currentplan", planOptions.find(opt => opt.value === company.currentplan));
      setValue("price", company.price);
      setValue("partner", partners.find((partner) => partner.value === company.partner_id));
      setValue(
        "app_access",
        company.app_access ? company.app_access.map((val) => ({ value: val, label: val.toUpperCase() })) : []
      );
      setValue("user_email", company.email);
      setValue("user_password", "");
      setValue("user_mobile", company.phone || "");
      clearErrors();
    } else {
      reset({
        company_name: "",
        contactperson: "",
        contactdesignation: "",
        email: "",
        phone: "",
        location_address: "",
        billingcycle: billingCycleOptions[0],
        plandate: null,
        currentplan: planOptions[0],
        price: "",
        partner: null,
        app_access: [],
        user_email: "",
        user_password: "",
        user_mobile: "",
      });
      clearErrors();
    }
  }, [isEditing, company, reset, setValue, clearErrors, partners]);
  useEffect(() => {
    if (!isEditing && companyEmail) {
      setValue("user_email", companyEmail);
    }
  }, [companyEmail, setValue, isEditing]);
  const generatePassword = async () => {
    const result = await Swal.fire({
      title: "Generate App Access Password",
      text: "Do you want to generate a random password or enter it manually?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Generate",
      cancelButtonText: "Manual",
    });
    if (result.isConfirmed) {
      const randomPassword = Math.random().toString(36).slice(-8);
      setValue("user_password", randomPassword);
    }
  };
  const onSubmit = async (data, event) => {
    event.preventDefault(); // Prevent default form submission
    const requestData = {
      company_name: data.company_name,
      contactperson: data.contactperson,
      contactdesignation: data.contactdesignation,
      email: data.email,
      phone: data.phone,
      location_address: data.location_address,
      billingcycle: data.billingcycle?.value || "monthly",
      plandate: data.plandate ? data.plandate.toISOString().split('T')[0] : null,
      currentplan: data.currentplan?.value || 1,
      price: data.price,
      partner_id: data.partner ? data.partner.value : null,
      app_access: data.app_access ? data.app_access.map((option) => option.value) : [],
      ...(isEditing ? {} : {
        user_email: data.user_email,
        user_password: data.user_password,
        user_mobile: data.user_mobile || null,
        type: "new_company"
      }),
      ip: "192.168.1.1",
    };
    try {
      const url = isEditing ? `${apiUrl}/company/update/${company.companyid}` : `${apiUrl}/company/signup`;
      const method = isEditing ? "put" : "post";
      const response = await axios[method](url, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      notify("success",`Company ${isEditing ? "updated" : "added"} successfully`);
      onSave(response.data.company);
      reset({
        company_name: "",
        contactperson: "",
        contactdesignation: "",
        email: "",
        phone: "",
        location_address: "",
        billingcycle: billingCycleOptions[0],
        plandate: null,
        currentplan: planOptions[0],
        price: "",
        partner: null,
        app_access: [],
        user_email: "",
        user_password: "",
        user_mobile: "",
      });
      onClose();
    } catch (error) {
      notify("error",`Failed to ${isEditing ? "update" : "add"} company. Please try again later.`);
    }
  };
  return (
    <div id="add_company" className="modal custom-modal fade show" style={{ display: 'block' }} role="dialog">
      <div className="modal-dialog modal-lg" style={{ margin: 0, position: 'fixed', right: 0, height: '100vh', width: '50%' }}>
    <div className="modal-content h-100">
          <div className="modal-header">
            <h5 className="modal-title">{isEditing ? "Edit Company" : "Add Company"}</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
      <div className="modal-body" style={{ maxHeight: "calc(100vh - 120px)", overflowY: "auto" }}>
                  <div className="scrollable-container">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Company Name <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      {...register("company_name", { required: "Company name is required" })}
                    />
                    {errors.company_name && <span className="text-danger">{errors.company_name.message}</span>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Contact Person <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      {...register("contactperson", { required: "Contact person is required" })}
                    />
                    {errors.contactperson && <span className="text-danger">{errors.contactperson.message}</span>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Contact Designation <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      {...register("contactdesignation", { required: "Contact designation is required" })}
                    />
                    {errors.contactdesignation && (
                      <span className="text-danger">{errors.contactdesignation.message}</span>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Phone <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      {...register("phone", { required: "Phone is required" })}
                    />
                    {errors.phone && <span className="text-danger">{errors.phone.message}</span>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Email <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="email"
                      {...register("email", { required: "Email is required" })}
                    />
                    {errors.email && <span className="text-danger">{errors.email.message}</span>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="col-form-label">Location Address</label>
                    <input className="form-control" type="text" {...register("location_address")} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="col-form-label">Billing Cycle</label>
                    <Controller
                      name="billingcycle"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={billingCycleOptions}
                          placeholder="Select Billing Cycle"
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="col-form-label">Plan Start Date</label>
                    <Controller
                      name="plandate"
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                          selected={field.value}
                          onChange={(date) => field.onChange(date)}
                          className="form-control"
                          placeholderText="Select Date"
                          dateFormat="yyyy-MM-dd"
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="col-form-label">Current Plan</label>
                    <Controller
                      name="currentplan"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={planOptions}
                          placeholder="Select Plan"
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="col-form-label">Price</label>
                    <input className="form-control" type="number" {...register("price")} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="col-form-label">Partner</label>
                    <Controller
                      name="partner"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={partners}
                          placeholder="Select Partner"
                          isClearable
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      App Access <span className="text-danger">*</span>
                    </label>
                    <Controller
                      name="app_access"
                      control={control}
                      rules={{ required: "Please select at least one app access option" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={appAccessOptions}
                          isMulti
                          placeholder="Select App Access"
                        />
                      )}
                    />
                    {errors.app_access && <span className="text-danger">{errors.app_access.message}</span>}
                  </div>
                </div>
                {!isEditing && (
                  <>
                    <div className="col-md-12">
                      <h6 className="mt-3">App Access Credentials</h6>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">
                          Username (Email) <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="email"
                          {...register("user_email", { required: "Username (email) is required" })}
                        />
                        {errors.user_email && <span className="text-danger">{errors.user_email.message}</span>}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">
                          Password <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            className="form-control"
                            type="text"
                            {...register("user_password", { required: "Password is required" })}
                          />
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={generatePassword}
                          >
                            Generate
                          </button>
                        </div>
                        {errors.user_password && <span className="text-danger">{errors.user_password.message}</span>}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Mobile Number (Optional)</label>
                        <input
                          className="form-control"
                          type="text"
                          {...register("user_mobile")}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </form>
          </div>
               </div>
          <div className="modal-footer" >
              <button className="btn btn-secondary me-2" onClick={onClose}>
                Cancel
              </button>
              <button className="btn btn-primary submit-btn" onClick={handleSubmit(onSubmit)}>
                {isEditing ? "Save Changes" : "Submit"}
              </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CompanyModelPopup;